import React from 'react';

export default function CheckBoxContainer(props) {
    return (
        <div className="col-start-10 col-end-13 flex items-center justify-center">
            {props.children}
        </div>
    );
}
